import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-family';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchFamilyNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsCivilStatusShared scope={IdAmbito.Cancellazioni} />
    </Fragment>
  );
};

ResearchFamilyNotificationsCivilStatusPage.displayName =
  'Research Family Notifications CivilStatusPage component';

export default ResearchFamilyNotificationsCivilStatusPage;
